import type { ComponentType, SVGProps } from 'react';
import { EmptyState } from '@immo/ui-kit';
import { LockIcon, PlugIcon, WarningTriangleIcon } from '@/components/layout/icons';
import { useTranslations } from '@/i18n/use-translations';

export type LandIqPageErrorCode =
  'admin.landiq.unreachable' | 'admin.landiq.credential-rejected' | 'admin.landiq.not-configured';

const ICONS: Record<LandIqPageErrorCode, ComponentType<SVGProps<SVGSVGElement>>> = {
  'admin.landiq.unreachable': WarningTriangleIcon,
  'admin.landiq.credential-rejected': LockIcon,
  'admin.landiq.not-configured': PlugIcon,
};

export const LANDIQ_PAGE_ERROR_CODES = Object.keys(ICONS) as ReadonlyArray<LandIqPageErrorCode>;

export function isLandIqPageErrorCode(code: string | undefined): code is LandIqPageErrorCode {
  return LANDIQ_PAGE_ERROR_CODES.some((candidate) => candidate === code);
}

/** Renders from the code only, never the wire message (ADR 0014). */
export function LandIqErrorState({ code }: { readonly code: LandIqPageErrorCode }) {
  const tErrors = useTranslations('errors');
  const Icon = ICONS[code];

  return (
    <div className="flex h-full min-h-0 items-center justify-center">
      <EmptyState title={tErrors(code)} icon={<Icon className="h-16 w-16" aria-hidden />} />
    </div>
  );
}
